Backbone = require 'backbone'

class SupportDropDownModel extends Backbone.Model
  initialize: ->
    @url = "#{window.SUPPORTBASEURL}/fetch?key=dropdowns&type=dropdowns&should_display_cms_content=#{experiments.shouldDisplayCMSContentForUS}"

module.exports = SupportDropDownModel
